module.exports = __webpack_public_path__ + "img/ab-testing.77b810bf.svg";